// The shop is a product & education catalog (no prices, no cart). Product CTAs
// open a WhatsApp chat with a prefilled enquiry instead of adding to a cart.
export const ENQUIRY_WHATSAPP = '255754690738'; // +255 754 690 738

export function enquiryLink(productName?: string): string {
  const text = productName
    ? `Hello DentoPharma, I would like to enquire about ${productName}.`
    : 'Hello DentoPharma, I would like to enquire about a product.';
  return `https://wa.me/${ENQUIRY_WHATSAPP}?text=${encodeURIComponent(text)}`;
}
